<template>
  <div class="flex flex-col items-start md:items-center pb-8 pt-6 px-6 md:pb-10 md:pt-8 md:px-8">
    <slot />
  </div>
</template>
